<template>
  <div>
    <div class="mb-1">
      <h4 class="mb-0">
        Кто имеет право
      </h4>
      <div class="text-muted small">
        Выберите право — покажем роли, которые его дают, и людей с этими ролями. Суперадмин имеет любое право.
      </div>
    </div>

    <b-card class="mb-1">
      <v-select
        v-model="permission"
        :options="permissionOptions"
        label="text"
        :reduce="option => option.value"
        placeholder="Право: название или ключ"
        @input="load"
      />
    </b-card>

    <b-card
      v-if="result"
      no-body
    >
      <b-card-body>
        <div class="mb-1">
          <strong>Роли:</strong>
          <b-badge
            v-for="role in result.roles"
            :key="role.id"
            variant="light-primary"
            class="mr-50"
          >
            {{ role.name }}
          </b-badge>
        </div>
        <b-table
          :items="result.users"
          :fields="fields"
          responsive
          show-empty
          empty-text="Ни у кого"
          class="mb-0"
        >
          <template #cell(name)="{ item }">
            {{ userName(item) }}
            <div class="small text-muted">
              #{{ item.id }} · {{ item.email }}
            </div>
          </template>
          <template #cell(role)="{ item }">
            {{ roleName(item.roleId) }}
          </template>
          <template #cell(starts)="{ item }">
            <span v-if="item.startMode === 'all'">все</span>
            <span v-else>{{ START_MODE_TITLES[item.startMode].toLowerCase() }}: {{ item.startIds.map(id => `#${id}`).join(', ') || '—' }}</span>
          </template>
        </b-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BBadge, BCard, BCardBody, BTable,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import aclApi from '@/services/acl-api.service'
import { loadCatalog, START_MODE_TITLES, userName } from './catalog'

export default {
  name: 'AclWhoHasPage',
  components: {
    BBadge, BCard, BCardBody, BTable, vSelect,
  },
  data() {
    return {
      START_MODE_TITLES,
      catalog: null,
      permission: this.$route.query.permission || null,
      result: null,
      fields: [
        { key: 'name', label: 'Пользователь' },
        { key: 'role', label: 'Через роль' },
        { key: 'starts', label: 'Старты' },
      ],
    }
  },
  computed: {
    permissionOptions() {
      if (!this.catalog) return []
      return this.catalog.permissions.map(p => ({ value: p.key, text: `${p.group} · ${p.title} (${p.key})` }))
    },
  },
  async created() {
    this.catalog = await loadCatalog()
    if (this.permission) this.load()
  },
  methods: {
    userName,
    roleName(id) {
      const role = this.result.roles.find(r => r.id === id)
      return role ? role.name : `#${id}`
    },
    async load() {
      if (!this.permission) {
        this.result = null
        return
      }
      if (this.$route.query.permission !== this.permission) {
        this.$router.replace({ query: { permission: this.permission } }).catch(() => {})
      }
      this.result = (await aclApi.whoHas(this.permission)).data
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
